import confetti from 'canvas-confetti';

/**
 * 🎉 useConfetti - Apple-style celebration animations
 * Provides various confetti effects for success moments
 */
export const useConfetti = () => {

    /**
     * 🎊 Standard celebration burst - for payment success
     */
    const celebrate = () => {
        confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 },
            colors: ['#10b981', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444']
        });
    };

    /**
     * 🏆 Achievement unlock - for first sale, badge earned
     */
    const achievementUnlock = () => {
        const duration = 2000;
        const end = Date.now() + duration;

        const frame = () => {
            confetti({
                particleCount: 3,
                angle: 60,
                spread: 55,
                origin: { x: 0, y: 0.6 },
                colors: ['#fbbf24', '#f59e0b', '#d97706']
            });
            confetti({
                particleCount: 3,
                angle: 120,
                spread: 55,
                origin: { x: 1, y: 0.6 },
                colors: ['#fbbf24', '#f59e0b', '#d97706']
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        };
        frame();
    };

    /**
     * ⭐ Star shower - for 5-star reviews
     */
    const starShower = () => {
        confetti({
            particleCount: 50,
            spread: 100,
            origin: { y: 0.3 },
            shapes: ['star'],
            colors: ['#fbbf24', '#fcd34d', '#fef08a']
        });
    };

    /**
     * 🎯 Quick pop - subtle micro-celebration
     */
    const quickPop = () => {
        confetti({
            particleCount: 30,
            spread: 50,
            origin: { y: 0.7 },
            startVelocity: 20,
            gravity: 1.2,
            colors: ['#10b981', '#34d399']
        });
    };

    return {
        celebrate,
        achievementUnlock,
        starShower,
        quickPop
    };
};

export default useConfetti;
